





































import {
  computed,
  onMounted,
  ref,
  watch,
  defineComponent,
  PropType,
  nextTick
} from '@vue/composition-api';
import { Rect as RectType } from '../../types';
import { CSSProperties } from '@/components/types';

export default defineComponent({
  name: 'EdgeText',

  props: {
    x: { type: Number, required: true },
    y: { type: Number, required: true },
    label: {
      type: String,
      required: true
    },
    labelStyle: { type: Object as PropType<CSSProperties>, default: () => {} },
    labelShowBg: {
      type: Boolean,
      default: true
    },
    labelBgStyle: {
      type: Object as PropType<CSSProperties>,
      default: () => ({})
    },
    labelBgPadding: {
      type: Array as PropType<number[]>,
      default: () => [2, 4]
    },
    labelBgBorderRadius: { type: Number, default: 2 }
  },

  setup(props) {
    const box = ref<RectType>({ x: 0, y: 0, width: 0, height: 0 });

    const el = ref<SVGTextElement | null>(null);

    const transform = computed(
      () =>
        `translate(${props.x - box.value.width / 2} ${props.y -
          box.value.height / 2})`
    );

    onMounted(getBox);

    watch(
      [() => props.x, () => props.y, el, () => props.label],
      () => nextTick(() => getBox()),
      {
        flush: 'post'
      }
    );

    function getBox() {
      if (!el.value) {
        return;
      }

      const nextBox = el.value.getBBox();

      if (
        nextBox.width !== box.value.width ||
        nextBox.height !== box.value.height
      ) {
        box.value = nextBox;
      }
    }

    return {
      transform,
      box,
      el
    };
  }
});
